/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicInventoryFiltersOperationFilter {
    From: Date;
    To: Date;
    /**
     * 1 = Enqueued, 2 = Processing, 3 = Processed
     */
    Status?: Open360BusinessLogicInventoryFiltersOperationFilter.StatusEnum;
    SearchAfter?: Date;
    Limit?: number;
}
export namespace Open360BusinessLogicInventoryFiltersOperationFilter {
    export type StatusEnum = 1 | 2 | 3;
    export const StatusEnum = {
        NUMBER_1: 1 as StatusEnum,
        NUMBER_2: 2 as StatusEnum,
        NUMBER_3: 3 as StatusEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicInventoryFiltersOperationFilter.ts